export default {
  'approvalFiltersExternalUsers.form.row': 'Filtro de usuario externo',
  'approvalFiltersExternalUsers.form.addRow': 'Agregar filtro de usuario externo',
  'approvalFiltersExternalUsers.form.noRows':
    'Aún no hay filtros de usuario externo. Agrega al menos uno.',
};
